import LendingWorkQueuePage from "../lending-queue/LendingWorkQueuePage";

const BarghPayWorkQueuePage = () => (
  <LendingWorkQueuePage
    partnerCode="BARQ_PAY"
    partnerTitle="برق‌پی"
    subtitle="پیگیری متمرکز فرآیند وام برق‌پی بر اساس مراحل گردش کار"
  />
);

export default BarghPayWorkQueuePage;
